/*! Copyright (c) Safe As Milk. All rights reserved. */
class ProductSingle extends HTMLElement {
    #variant;
    connectedCallback() {
        this.mediaGallery = this.querySelector("media-gallery");
        this.#moveModalsFromStickyScrollContainer();
    }
    updateMedia() {
        if (!this.mediaGallery || !this.#variant.featured_media) return;
        const mediaId = this.#variant.featured_media.id;
        this.mediaGallery.goToSlide(mediaId);
    }
    set variant(variant) {
        // let test = variant.currentVariant.featured_media
        // console.log("hello.....", variant)
        this.#variant = variant;
        this.updateMedia();

        // if(variant.featured_media && variant.featured_media.alt) {
        //     document.querySelectorAll('[thumbnail-alt]').forEach(img => img.style.display = 'none')
        //     const currentImgAlt = variant.featured_media.alt
        //     const result1 = currentImgAlt.split('|')[1].trim();
        //     const thumbnailSelector = `[thumbnail-alt = '${result1}']`
        //     document.querySelectorAll(thumbnailSelector).forEach(img => img.style.display = 'block')
        // } else {
        //     document.querySelectorAll('[thumbnail-alt]').forEach(img => img.style.display = 'block')
        // }
    }
    get variant() {
        return this.#variant;
    }
    #moveModalsFromStickyScrollContainer() {
        const modals = this.querySelectorAll("sticky-scroll modal-dialog, sticky-scroll popup-dialog");
        modals.forEach((modal => {
            this.append(modal);
        }));
    }
}

customElements.define("product-single", ProductSingle);
//# sourceMappingURL=product-single.js.map


